// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
export const ownerSettlement = {
  head: {
    title: "Proprietário e repasse",
    sub: "Se você administra esta acomodação para outro proprietário, defina quem recebe, a sua comissão e como é feito o repasse. É com isso que se calculam os repasses dele e as suas análises de gestor.",
  },
  loading: "Carregando a configuração…",
  loadError: {
    title: "Não foi possível carregar a configuração",
    text: "Verifique a conexão e tente novamente.",
    retry: "Tentar novamente",
  },
  master: {
    label: "Administro esta acomodação para um proprietário",
    hintOff: "A acomodação é sua: as reservas contam como receita própria.",
    hintOn: "As reservas são repassadas ao proprietário com as condições abaixo.",
    kept: "O que você tinha configurado fica salvo caso volte a ativar.",
    introTitle: "Ao ativar:",
    intro1: "Você escolhe o proprietário e quem recebe as reservas.",
    intro2: "Define a sua comissão, o imposto e quem fica com a limpeza.",
    intro3: "Vê na hora como fica o repasse dele.",
  },
  owner: {
    title: "Proprietário",
    hint: "A pessoa ou empresa a quem você faz o repasse desta acomodação.",
    placeholder: "Escolha um proprietário",
    new: "Novo proprietário",
    add: "Adicionar proprietário",
    edit: "Editar",
    emptyTitle: "Você ainda não tem proprietários",
    emptyText: "Adicione o dono desta acomodação para poder fazer o repasse.",
    missing: "Sem proprietário atribuído, o repasse desta acomodação não terá destinatário.",
    pending: "Atribuído ao salvar",
    taxId: "Doc. fiscal",
    addTaxId: "Adicionar doc. fiscal",
    iban: "IBAN",
    addIban: "Adicionar IBAN",
  },
  ownerForm: {
    titleNew: "Novo proprietário",
    titleEdit: "Editar proprietário",
    sub: "Os dados dele aparecem nos repasses das acomodações que você administra para ele.",
    close: "Fechar",
    name: "Nome ou razão social",
    taxId: "CPF/CNPJ ou NIF",
    taxIdHint: "O número de identificação fiscal, de qualquer país.",
    taxIdDoubt: "Se for um NIF espanhol, o caractere de controle não confere. Se for de outro país, ignore este aviso.",
    email: "E-mail",
    phone: "Telefone",
    iban: "IBAN",
    ibanPlaceholder: "PT50 0000 0000 0000 0000 0000 0",
    ibanHint: "A conta para onde você transfere a parte dele.",
    ibanOk: "IBAN válido · {country}",
    address: "Endereço",
    notes: "Observações",
    notesPlaceholder: "O que vocês combinaram, o dia do pagamento…",
    sharedNote: "Ele também é proprietário de mais {n} acomodação: as alterações aparecerão lá. | Ele também é proprietário de mais {n} acomodações: as alterações aparecerão em todas.",
    cancel: "Cancelar",
    save: "Salvar proprietário",
    saving: "Salvando…",
    created: "Proprietário criado",
    updated: "Proprietário atualizado",
    deleted: "Proprietário excluído",
    errName: "Informe o nome ou a razão social.",
    errEmail: "Confira o e-mail: ele não parece válido.",
    errIbanFormat: "Um IBAN começa com o código do país e dois dígitos de controle (PT50…).",
    errIbanCheck: "Os dígitos de controle não conferem: confira se foi copiado corretamente.",
    errIbanLength: "Um IBAN ({country}) tem {expected} caracteres e este tem {actual}.",
    errSave: "Não foi possível salvar o proprietário. Tente novamente.",
    errDelete: "Não foi possível excluir o proprietário. Tente novamente.",
    delete: "Excluir proprietário",
    deleteTitle: "Excluir {name}?",
    deleteText: "Ele sai da sua lista de proprietários. Não é possível desfazer.",
    deleteConfirm: "Excluir",
    deleteBlocked: "Não é possível excluir: ele é proprietário de {n} acomodação. Remova-o dela antes. | Não é possível excluir: ele é proprietário de {n} acomodações. Remova-o de cada uma antes.",
    discardTitle: "Descartar as alterações?",
    discardText: "O que você digitou sobre este proprietário será perdido.",
    discardConfirm: "Descartar",
    discardCancel: "Continuar editando",
  },
  units: {
    title: "Proprietário de cada unidade",
    hint: "Se alguma unidade for de outro dono, escolha-o aqui. As demais são repassadas ao proprietário do anúncio.",
    inherit: "O do anúncio",
    summaryNone: "Todas são do proprietário do anúncio",
    summarySome: "{n} unidade com outro proprietário | {n} unidades com outro proprietário",
  },
  collection: {
    title: "Quem recebe as reservas?",
    hint: "Muda para onde vai o dinheiro, não o que fica para o proprietário.",
    ownerLabel: "O proprietário recebe",
    ownerDesc: "As plataformas e o seu site pagam a ele. Depois ele paga a sua fatura de honorários (e a limpeza, se for sua).",
    managerLabel: "O gestor recebe",
    managerDesc: "O dinheiro das reservas chega até você. Você fica com a sua parte e transfere a dele.",
    flowBooking: "Reserva",
    flowOwner: "Proprietário",
    flowYou: "Você",
  },
  commission: {
    title: "Sua comissão",
    percent: "Porcentagem de comissão",
    vat: "Imposto sobre a sua comissão",
    base: "Calculada sobre",
    presetTotal: "Total da reserva",
    presetAccommodation: "Hospedagem sem limpeza",
    presetNet: "Líquido após a comissão da OTA",
    presetDescNet: "{concepts}, sem a parte deles na comissão da OTA",
    presetNetClean: "Net of OTA and cleaning",
    presetDescNetClean: "What the owner keeps before your fee: the total minus the OTA, its VAT and cleaning",
    exampleBase: "base no exemplo",
    custom: "Personalizado",
    customize: "Ajustar manualmente",
    baseLabel: "Sobre qual valor",
    gross: "O que o hóspede paga",
    net: "O que sobra após a comissão da OTA",
    netClean: "What's left after the OTA and cleaning",
    concepts: "Quais itens entram",
    warnTaxes: "As taxas não são receita: normalmente não se cobra comissão sobre elas.",
    fixTaxes: "Tirar as taxas",
    warnCleaning: "Você está cobrando comissão sobre uma limpeza que já fica com você.",
    fixCleaning: "Tirar a limpeza",
    warnDeposit: "A caução é devolvida ao hóspede: normalmente não se cobra comissão sobre ela.",
    fixDeposit: "Tirar a caução",
    errPercent: "Informe uma porcentagem entre 0 e 100.",
    errConcepts: "Escolha pelo menos um item.",
  },
  concepts: {
    accommodation: "Hospedagem",
    cleaning: "Limpeza",
    taxes: "Taxas",
    extras: "Extras",
    deposit: "Caução",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "hospedagem",
    cleaning: "limpeza",
    taxes: "taxas",
    extras: "extras",
    deposit: "caução",
  },
  cleaning: {
    title: "Limpeza",
    hint: "Quem fica com o que o hóspede paga pela limpeza?",
    owner: "É do proprietário",
    ownerDesc: "Fica no líquido dele: não é descontada.",
    manager: "É sua",
    managerDesc: "Você cuida dela e ela é descontada do proprietário.",
    charged: "O que o hóspede paga pela limpeza",
    fixed: "Um valor fixo por estadia",
    fixedAmount: "Valor por estadia",
    fixedHint: "Se uma reserva tiver vários quartos, o valor conta uma vez por quarto.",
    errAmount: "Informe o valor fixo da limpeza por estadia.",
  },
  ota: {
    title: "Comissão de cada OTA",
    moved: "A % de cada OTA é configurada no cartão “{card}”.",
    open: "Abrir “{card}”",
  },
  example: {
    title: "Repasse de exemplo",
    sub: "Uma reserva de {total} pelo {channel}, com as suas condições atuais.",
    guest: "O que o hóspede paga",
    platform: "O que fica com o {channel}",
    platformNote: "A comissão: {pct}% de {base} ({concepts}).",
    platformYours: "Valem as suas % de “{card}”, mesmo que o {channel} envie a comissão dele.",
    platformReal: "Se o {channel} enviar a comissão de uma reserva, é ela que vale.",
    platformRule: "Se você definir a % do {channel} em “{card}”, vale a sua; se não, a comissão dele.",
    otaVat: "Imposto sobre a comissão do {channel} ({pct}%)",
    changeIn: "Alterar em “{card}”",
    changeWhere: "É alterada em “{card}”.",
    notOwner: "O que não é do proprietário",
    taxes: "Taxas e impostos",
    taxesNote: "Não são receita do proprietário.",
    cleaning: "Limpeza que fica com você",
    cleaningNoteCharged: "O que o hóspede paga por ela.",
    cleaningNoteFixed: "O seu valor fixo por estadia.",
    fees: "Seus honorários de gestão",
    commission: "Comissão: {pct}% de {base}",
    commissionBase: "Base: {concepts}.",
    commissionBaseNet: "Base: {concepts}, sem a parte deles na comissão do {channel}.",
    commissionBaseNetClean: "Base: what the owner keeps after {channel}, its VAT and cleaning.",
    vat: "Imposto sobre a sua comissão ({pct}%)",
    invoice: "Total da sua fatura de honorários",
    net: "Líquido para o proprietário",
    netNote: "O que é dele nesta reserva.",
    netNegative: "Os descontos superam o que a reserva deixa.",
    splitTitle: "Como se dividem os {total}",
    legendTaxes: "Taxas",
    legendCleaning: "Limpeza (sua)",
    legendFees: "Seus honorários",
    legendOwner: "Proprietário",
    legendDeficit: "O que falta",
    transferTitle: "Você transfere {amount}",
    transferTitleTo: "Você transfere {amount} para {owner}",
    transferInvoice: "E emite a sua fatura de honorários de {amount}.",
    owesTitle: "O proprietário deve {amount} a você",
    owesTitleFrom: "{owner} deve {amount} a você",
    owesInvoice: "Não há nada a transferir. A sua fatura de honorários é de {amount}.",
    owesHint: "Neste exemplo, os descontos superam o que a reserva deixa.",
    collectTitle: "O proprietário paga {amount} a você",
    collectTitleFrom: "{owner} paga {amount} a você",
    collectBreakdown: "É a sua fatura de honorários ({fees}).",
    collectBreakdownCleaning: "A sua fatura de honorários ({fees}) mais a limpeza ({cleaning}).",
    ownerLoses: "Com essas condições, o proprietário perde {amount} nesta reserva.",
    foot: "Valores de exemplo. O repasse real usa o detalhamento de cada reserva.",
    footNoOtaVat: "Sem o imposto sobre a comissão da OTA.",
  },
  footer: {
    save: "Salvar alterações",
    saving: "Salvando…",
    unsaved: "Alterações não salvas",
    saved: "Salvo",
    fixErrors: "Revise os campos destacados.",
    errSave: "Não foi possível salvar. Tente novamente.",
    peekLabel: "Fica para o proprietário",
    peekAria: "Ver o repasse de exemplo: fica para o proprietário {amount}",
  },
};
